export const getBusinessNameStyles = () => ({
  container: {
    '& .business-name-container': {
      width: 'auto',
    },
  },
});
